import { jsx as _jsx } from "react/jsx-runtime";
var Twitter = function Twitter(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: 1.25 * size,
    height: size,
    viewBox: "0 0 40 32",
    children: /*#__PURE__*/_jsx("path", {
      fill: !ignoreColor ? color : undefined,
      d: "M39.536 3.787a15.828 15.828 0 0 1-4.581 1.265A8.316 8.316 0 0 0 38.428.647a17.09 17.09 0 0 1-5.03 1.886C31.81.965 29.705-.023 27.369-.023a8.107 8.107 0 0 0-7.886 9.996C12.72 9.575 6.778 6.377 2.784 1.517c-.722 1.124-1.13 2.526-1.13 4.023a8.062 8.062 0 0 0 3.579 6.705 7.813 7.813 0 0 1-3.685-1.013c.04.055.04.088.04.123a8.096 8.096 0 0 0 6.455 7.912c-.587.189-1.322.293-2.081.293a8.25 8.25 0 0 1-1.583-.153c1.126 3.247 4.1 5.554 7.621 5.619a16.172 16.172 0 0 1-10.038 3.459h-.03c-.68 0-1.352-.041-2.012-.121a23.214 23.214 0 0 0 12.487 3.637h.028c14.919 0 23.077-12.31 23.077-22.986 0-.35-.007-.699-.023-1.045a16.578 16.578 0 0 0 4.01-4.125z"
    })
  });
};
export default Twitter;